import type { IReorderMenuItem, IReorderMenuItemResponse } from './types';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const reorderMenuItem = async ({
  itemId,
  newDisplayOrder,
}: IReorderMenuItem): Promise<IReorderMenuItemResponse> => {
  const uri = `${API_URL}/items/${itemId}/reorder`;
  try {
    const res = await fetch(uri, {
      method: 'PATCH',
      body: JSON.stringify({ display_order: newDisplayOrder }),
      cache: 'reload',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    throw new Error('Could not reorder menu item', { cause: e });
  }
};
